@if (pages.length > 0) {
  <div class="toolbar">
    @for (page of pages; track page) {
      <dx-button class="toolbar-item" [elementAttr]="{ title: page.caption }" (onClick)="setActivePage(page)">
        <img [src]="page.imgPath" />
        @if (page.orders?.length) {
          <span class="total-count">{{ page.orders?.length }}</span>
        }
      </dx-button>
    }
  </div>
  <div class="info">
    <dx-button stylingMode="text" (onClick)="closeClick()" class="btn-close">
      <img src="/assets/images/icon_close.png" />
    </dx-button>
    <app-notifications-page [caption]="activePage?.caption" [orders]="activePage?.orders" (onClose)="closeClick()"></app-notifications-page>
  </div>
} @else {
  <div class="no-notifications">
    <dx-button stylingMode="text" (onClick)="closeClick()" class="btn-close">
      <img src="/assets/images/icon_close.png" />
    </dx-button>
    <img src="/assets/images/notification-empty-state.svg" />
    <div class="mt-2 mb-4 text-center">{{ 'NOTIFICATIONS_EMPTY' | translate }}</div>
  </div>
}
